import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { useParams } from 'react-router-dom';
import { SuspectIdentificationBlockData } from 'models/suspectIdentificationBlockData';

type Props = {
  enabled?: boolean;
  suspectIdentificationOrUserBlockId?: string;
};

export const useSuspectIdentification = ({
  enabled = true,
  suspectIdentificationOrUserBlockId,
}: Props) => {
  const { patient: userId } = useParams();
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchSuspectIdentification =
    async (): Promise<SuspectIdentificationBlockData> => {
      return await api({
        route: `/private/dashboard/user/${userId}/suspect-identification/${suspectIdentificationOrUserBlockId}`,
        token: userToken,
      });
    };

  const { data, isLoading, isError } = useQuery<
    SuspectIdentificationBlockData,
    Error
  >({
    queryKey: [
      'suspect-identification',
      userToken,
      userId,
      suspectIdentificationOrUserBlockId,
    ],
    queryFn: fetchSuspectIdentification,
    enabled:
      enabled &&
      isAuthenticated &&
      !loading &&
      !!userToken &&
      !!userId &&
      !!suspectIdentificationOrUserBlockId,
    refetchOnWindowFocus: false,
  });

  return {
    suspectIdentification: data ?? null,
    isLoading,
    isError,
  };
};
